import React__default from 'react';
import { Price } from '@grandvisionhq/common';

const PriceAside = ({ currency , price , prefix , className  })=>/*#__PURE__*/ React__default.createElement("div", {
        className: className
    }, prefix, " ", /*#__PURE__*/ React__default.createElement(Price, {
        value: price,
        centAmount: true,
        currency: currency
    }))
;

export { PriceAside };
//# sourceMappingURL=PriceAside.js.map
